(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OltUpdateFirmwareController', OltUpdateFirmwareController);

    OltUpdateFirmwareController.$inject = ['$scope', '$uibModalInstance', 'OltService', 'OltData', 'oltId'];

    function OltUpdateFirmwareController($scope, $uibModalInstance, OltService, OltData, oltId) {

        // Variables and Objects
        var vm = this;
        vm.requestRunning = false;
        vm.selectedFiles = [];

        // Set the message in the modal according the OLT Model
        vm.description = is8820G() ? '8820G' : '8820i';

        // Method handler
        vm.close = close;

        // Method API
        vm.updateFirmware = updateFirmware;

        initialize();

        function close() {
            if (!vm.requestRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        function updateFirmware() {
            vm.selectedFiles = [];
            vm.modelFirmware.files.forEach(function (item) {
                if (item.checked) {
                    vm.selectedFiles.push(item.name);
                }
            });
            if (is8820G() && vm.selectedFiles.length > 2) {
                errorUpdate({status: '400.1', config: {}})
            } else if (!is8820G() && vm.selectedFiles.length > 1) {
                errorUpdate({status: '400.2', config: {}})
            } else if (vm.formUpdateOlt.$valid && vm.selectedFiles.length && !vm.requestRunning) {
                var data = {
                    files: vm.selectedFiles,
                    oltId: vm.modelFirmware.oltId
                }

                var dataAction = {
                    action: 'updateOltConfirm',
                    methodService: 'updateOltFirmware',
                };
                OltService.confirmationOltModalConstructor([data], dataAction);
            }
        }

        // Request Callbacks
        function sucessGetFiles(data) {
            vm.modelFirmware = {
                oltId: data.oltId,
                oltName: data.oltName,
                files: data.files.map(function (item) {
                    return {name: item, checked: false}
                })
            };
        }

        function errorGetFiles(response) {
            OltService.errorModalConstructor(response, 'getFiles');
            close();
        }

        function successUpdate(data) {
            vm.requestRunning = false;
            OltService.successModalConstructor('updateFirmware');
        }

        function errorUpdate(response) {
            vm.requestRunning = false;
            OltService.errorModalConstructor(response, 'updateFirmware');
        }

        function is8820G() {
            return OltData.detail.model != 'Intelbras8820i';
        }

        function initialize() {
            vm.modelFirmware = {
                oltId: 0,
                oltName: '',
                files: []
            };
            OltService.getFiles(oltId).then(sucessGetFiles).catch(errorGetFiles);
        }
    }
})();